/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthSignupRouteImport } from './routes/_auth.signup'
import { Route as AuthLoginRouteImport } from './routes/_auth.login'
import { Route as AppTodosRouteImport } from './routes/_app.todos'
import { Route as AppStatsRouteImport } from './routes/_app.stats'
import { Route as AppSettingsRouteImport } from './routes/_app.settings'
import { Route as AppMoodRouteImport } from './routes/_app.mood'
import { Route as AppJournalRouteImport } from './routes/_app.journal'
import { Route as AppFocusRouteImport } from './routes/_app.focus'
import { Route as AppDashboardRouteImport } from './routes/_app.dashboard'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignupRoute = AuthSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AppTodosRoute = AppTodosRouteImport.update({
  id: '/todos',
  path: '/todos',
  getParentRoute: () => AppRoute,
} as any)
const AppStatsRoute = AppStatsRouteImport.update({
  id: '/stats',
  path: '/stats',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppMoodRoute = AppMoodRouteImport.update({
  id: '/mood',
  path: '/mood',
  getParentRoute: () => AppRoute,
} as any)
const AppJournalRoute = AppJournalRouteImport.update({
  id: '/journal',
  path: '/journal',
  getParentRoute: () => AppRoute,
} as any)
const AppFocusRoute = AppFocusRouteImport.update({
  id: '/focus',
  path: '/focus',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dashboard': typeof AppDashboardRoute
  '/focus': typeof AppFocusRoute
  '/journal': typeof AppJournalRoute
  '/mood': typeof AppMoodRoute
  '/settings': typeof AppSettingsRoute
  '/stats': typeof AppStatsRoute
  '/todos': typeof AppTodosRoute
  '/login': typeof AuthLoginRoute
  '/signup': typeof AuthSignupRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/dashboard': typeof AppDashboardRoute
  '/focus': typeof AppFocusRoute
  '/journal': typeof AppJournalRoute
  '/mood': typeof AppMoodRoute
  '/settings': typeof AppSettingsRoute
  '/stats': typeof AppStatsRoute
  '/todos': typeof AppTodosRoute
  '/login': typeof AuthLoginRoute
  '/signup': typeof AuthSignupRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/focus': typeof AppFocusRoute
  '/_app/journal': typeof AppJournalRoute
  '/_app/mood': typeof AppMoodRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_app/stats': typeof AppStatsRoute
  '/_app/todos': typeof AppTodosRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/signup': typeof AuthSignupRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/focus'
    | '/journal'
    | '/mood'
    | '/settings'
    | '/stats'
    | '/todos'
    | '/login'
    | '/signup'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/dashboard'
    | '/focus'
    | '/journal'
    | '/mood'
    | '/settings'
    | '/stats'
    | '/todos'
    | '/login'
    | '/signup'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/_auth'
    | '/_app/dashboard'
    | '/_app/focus'
    | '/_app/journal'
    | '/_app/mood'
    | '/_app/settings'
    | '/_app/stats'
    | '/_app/todos'
    | '/_auth/login'
    | '/_auth/signup'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/signup': {
      id: '/_auth/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof AuthSignupRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_app/todos': {
      id: '/_app/todos'
      path: '/todos'
      fullPath: '/todos'
      preLoaderRoute: typeof AppTodosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stats': {
      id: '/_app/stats'
      path: '/stats'
      fullPath: '/stats'
      preLoaderRoute: typeof AppStatsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/mood': {
      id: '/_app/mood'
      path: '/mood'
      fullPath: '/mood'
      preLoaderRoute: typeof AppMoodRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/journal': {
      id: '/_app/journal'
      path: '/journal'
      fullPath: '/journal'
      preLoaderRoute: typeof AppJournalRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/focus': {
      id: '/_app/focus'
      path: '/focus'
      fullPath: '/focus'
      preLoaderRoute: typeof AppFocusRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppDashboardRoute: typeof AppDashboardRoute
  AppFocusRoute: typeof AppFocusRoute
  AppJournalRoute: typeof AppJournalRoute
  AppMoodRoute: typeof AppMoodRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppStatsRoute: typeof AppStatsRoute
  AppTodosRoute: typeof AppTodosRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppDashboardRoute: AppDashboardRoute,
  AppFocusRoute: AppFocusRoute,
  AppJournalRoute: AppJournalRoute,
  AppMoodRoute: AppMoodRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppStatsRoute: AppStatsRoute,
  AppTodosRoute: AppTodosRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  AuthLoginRoute: typeof AuthLoginRoute
  AuthSignupRoute: typeof AuthSignupRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthLoginRoute: AuthLoginRoute,
  AuthSignupRoute: AuthSignupRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
